module.exports = __webpack_public_path__ + "327db414b61f5434468ffc544c4a2192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/promo/ts_runthetrickstrat.jpg
// module id = 434
// module chunks = 0